import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Cache bust: ?nocache=1 or ?refresh=1 forces a fresh load (redirect with t=timestamp)
let shouldRedirect = false;
if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  if (params.get('nocache') === '1' || params.get('refresh') === '1') {
    params.delete('nocache');
    params.delete('refresh');
    params.set('t', String(Date.now()));
    const qs = params.toString();
    window.location.replace(window.location.pathname + (qs ? '?' + qs : ''));
    shouldRedirect = true;
  }
}

if (!shouldRedirect) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
